import { HeaderHLPure, SimpleLoading } from '../../pures'
import { Container, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { TokenVolumeGraph, StatCard, SimpleCard, ExpenseSpeedometer } from '../../pures/dashboard'
import { DropDownList } from "@progress/kendo-react-dropdowns"

const UsageView = (props) => {
    const {
        isLoading,
        usagePart1,
        dailyTokenUsage,
        date,
        handleChangeDate,
        monthYearOptions
    } = props

    const { t } = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' })

    return (
        <>
            {isLoading
                ? <div className='loading'>
                    <SimpleLoading />
                </div>
                : (<div className={"dashboardView"}>
                    <Container>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <HeaderHLPure title={t("title")} />
                            </Grid>
                            
                            <Grid container item xs={16} spacing={1} className="reportsAndStatisticsView-dashboard">
                                <Grid item xs={16} md={2}>
                                    <SimpleCard 
                                        title={t('usagePeriod')}
                                    >
                                        <DropDownList
                                        id='assistantTone'
                                        name={'assistantTone'}
                                        className="eticket-dropdown-field"
                                        textField="text"  
                                        dataItemKey="value"
                                        data={monthYearOptions}
                                        value={monthYearOptions.find(option => option.value === date)}
                                        onChange={handleChangeDate}
                                    />
                                    </SimpleCard>
                                </Grid>
                                
                                <Grid item xs={16} md={2}>
                                    <StatCard
                                        className={'textCard'}
                                        title={t("name")}
                                        value={usagePart1.name}
                                    />
                                </Grid>
                                
                                <Grid item xs={16} md={4}>
                                    <StatCard
                                        className={'textCard'}
                                        title={t("averagePerConversation")}
                                        value={usagePart1.avgTokensPerConversation}
                                    />
                                </Grid>
                                
                                <Grid item xs={16} md={3}>
                                    <StatCard
                                        className={'textCard'}
                                        title={t("averagePerDay")}
                                        value={usagePart1.dailyAverageTokens}
                                    />
                                </Grid>
                            </Grid>

                            {/* Segunda fila: TokenVolumeGraph */}
                            <Grid item xs={16} md={9} className="rasd-graph">
                                <SimpleCard>
                                    <p class='dashboardView-card-title'>{t('tokenGraphTitle')}</p>
                                    <TokenVolumeGraph data={dailyTokenUsage} t={t} />
                                </SimpleCard>
                            </Grid>

                            <Grid item xs={16} md={3} className="rasd-speedometer">
                                <SimpleCard style={{ height: '100%' }}>
                                    <ExpenseSpeedometer data={usagePart1} t={t} />
                                </SimpleCard>
                            </Grid>
                        </Grid>
                    </Container>
                </div>)
            }
        </>
    )
}

export { UsageView as default }